export default function scrollTo(options: ScrollToOptions) {
  const wrapper = document.getElementById("main-content-wrapper");
  if (wrapper) {
    wrapper.scrollTo(options);
  }
}
